// src/Utils/IndexedDB.js
import { openDB } from "idb";

export async function initDB() {
    return openDB('ff-products-db', 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains('products')) {
                const store = db.createObjectStore('products', { keyPath: 'id' })
                store.createIndex('name', 'name')
            }
        }
    })
}

export async function storeProductsInIndexedDB(products) {
    const db = await initDB()
    const tx = db.transaction('products', 'readwrite')
    const store = tx.objectStore('products')

    products.forEach(product => {
        store.put(product)
    })

    await tx.done
}

export async function clearProductsInIndexedDB() {
    const db = await initDB();
    const tx = db.transaction('products', 'readwrite');
    await tx.objectStore('products').clear();
    await tx.done;
}


export async function getGroupedProductsByNamePrefix() {
    const db = await initDB();
    const tx = db.transaction('products', 'readonly');
    const store = tx.objectStore('products');

    const allProducts = await store.getAll();

    const grouped = {};

    allProducts.forEach(product => {
        // 1. Extract prefix before first comma
        const rawPrefix = product.name.split(',')[0].trim();

        // 2. Normalize it
        const normalizedKey = normalizeBrandKey(rawPrefix);

        // 3. Group under normalized key
        if (!grouped[normalizedKey]) {
            grouped[normalizedKey] = {
                displayName: capitalizeWords(rawPrefix),
                products: []
            };
        }

        grouped[normalizedKey].products.push(product);
    });

    return grouped;
}

// 🔧 Normalize key: lowercase, remove accents, trim
export function normalizeBrandKey(text) {
    return text
        .toLowerCase()
        .normalize("NFD")                   // break accents
        .replace(/[\u0300-\u036f]/g, '')   // remove accents
        .replace(/’/g, "'")                // curly to straight apostrophes
        .trim();
}

// ✨ Capitalize each word (for display)
function capitalizeWords(str) {
    return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, match => match.toUpperCase());
}


export async function findProductByName(name) {
    if (!name || typeof name !== 'string') {
        console.warn('Invalid or missing product name:', name);
        return null;
    }

    const db = await initDB();
    const tx = db.transaction('products', 'readonly');
    const store = tx.objectStore('products');
    const index = store.index('name');

    // Now safe to call get()
    const product = await index.get(name);
    if (product) {
        return product;
    }

    // fallback manual search
    const allProducts = await store.getAll();
    return allProducts.find(p => p.name && p.name.toLowerCase() === name.toLowerCase()) || null;
}

